<template>
	<section :id="id" class="image_list_section" v-bind:style="{'background-color': bgColor, 'text-align': alignText}">
		<h2 v-if="title" v-html="title"></h2>
		<div class="image_list"
		     v-bind:class="{ autoHeight: isAutoHeight, multiline: isMultiline, image_list_boxed: isBoxed}"
		     v-bind:style="{'gap': margin}">
			<div
					v-for="imagelistItem in imagelistItems"
					v-bind:key="imagelistItem.id"
					v-lazy:background-image="require('../assets/images/'+imagelistItem.image)"
					class="image_list_element"
					v-bind:style="{'width': columnsWidth(columns), 'flex-basis': columnsWidth(columns)}"
			>
				<img v-if="isAutoHeight" v-lazy="require('../assets/images/'+imagelistItem.image)" alt="" style="width: 100%"
				     v-bind:style="{'box-shadow': boxShadow(imagelistItem.shadowWidth)}">
				<div v-if="imagelistItem.legende && imagelistItem.darkLegende != 'true'" class="image_section_legende"
				     v-html="imagelistItem.legende"></div>
				<div v-else-if="imagelistItem.legende && imagelistItem.darkLegende == 'true'" class="image_section_legende dark"
				     v-html="imagelistItem.legende"></div>
				<div v-if="imagelistItem.description" class="image_section_description"
				     v-html="imagelistItem.description"></div>
			</div>
		</div>
		<slot></slot>
	</section>

</template>

<script>

import Vue2Filters from "vue2-filters";

export default {
	name: "ImageList",
	mixins: [Vue2Filters.mixin],
	components: {},
	data: function () {
		return {
			isAutoHeight: (this.autoHeight != "false"),
			isBoxed: (this.boxed),
			isMultiline: (this.imagelistItems.length > this.columns)
		};
	},
	props: {
		imagelistItems: {
			type: Array
		},
		title: {
			type: String,
			default: ""
		},
		id: {
			type: String,
			default: ""
		},
		image: {
			type: String,
			default: ""
		},
		columns: {
			type: Number,
			default: 1
		},
		margin: {
			type: String,
			default: ""
		},
		autoHeight: {
			type: String,
			default: "false"
		},
		boxed: {
			type: String,
			default: ""
		},
		legende: {
			type: String,
			default: ""
		},
		bgColor: {
			type: String,
			default: ""
		},
		description: {
			type: String,
			default: ""
		},
		darkLegende: {
			type: String,
			default: ""
		},
		shadowWidth: {
			type: String,
			default: "0"
		},
		alignText: {
			type: String,
			default: "left"
		}
	},
	methods: {
		imgPath: function (image) {
			return require("../assets/images/" + image);
		},
		columnsWidth: function (columns) {
			columns = 100 / columns;
			return columns + "%";
		},
		boxShadow: function (shadowWidth) {
			if (shadowWidth) {
				return "0px 0px " + shadowWidth + " rgba(0,0,0,0.05)";
			} else {
				return "none;";
			}
		}
	},
	mounted() {
		console.log(this.columns);
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@use '@/assets/scss/partials/variables' as *;
@use '@/assets/scss/partials/mixins' as *;


.image_list_section {
	padding: 5rem;

	h2 {
		display: inline-block;
		font-family: $IsidoraBold;
		font-size: 4rem;
		margin-bottom: 4rem;
		position: relative;

		&:after {
			background-color: $black;
			bottom: -1.5rem;
			content: '';
			height: 0.4rem;
			left: 50%;
			position: absolute;
			transform: translateX(-50%);
			width: 8rem;
		}
	}

	.image_list {
		align-content: flex-start;
		align-items: flex-start;
		display: flex;
		flex-direction: row;
		height: auto;
		justify-content: space-between;

		&_boxed {
			margin: auto;
			max-width: 160rem;
			text-align: center;
			@include breakpoint(lt-sm) {
				padding: 0 3.5rem;
			}
		}

		&.multiline {
			flex-wrap: wrap;
		}

		@include breakpoint(lt-sm) {
			flex-direction: column;
		}

		.image_list_element {
			background-position: center;
			background-repeat: no-repeat;
			background-size: cover;
			height: auto;
			position: relative;
			@include breakpoint(lt-sm) {
				flex-basis: 100% !important;
				width: 100% !important;
			}

			.image_section_description {
				font-size: 2rem;
				padding-top: 4rem;
			}
		}

		&.autoHeight {
			.image_list_element {
				background-image: none !important;
			}
		}

		&:not(.autoHeight) {
			.image_list_element {
				background-position: center;
				background-repeat: no-repeat;
				background-size: cover;
				height: 60vh;
				position: relative;

				@include breakpoint(lt-md) {
					height: 30vh;
				}

				@include breakpoint(lt-sm) {
					flex: unset;
					height: calc(900vw / 16);
				}

				.image_section_legende {
					background-color: transparent;
					bottom: 0;
					color: $white;
					padding: $padding-simple;
					position: absolute;
					right: 0;
					transition: $E-defaultTime $E-default;

					&.dark {
						color: $black;
					}
				}

				&:hover {
					.image_section_legende {
						background-color: rgba(0, 0, 0, 0.5);
						color: $white;
						transition: $E-defaultTime $E-default;
					}
				}
			}
		}
	}
}

.case {
	.image_list_section {
		h2 {
			color: $black;
			font-size: 2.8rem;
			margin-bottom: 4rem;

			&:after {
				display: none;
			}
		}
	}
}

</style>
